import { render, staticRenderFns } from "./Exci.vue?vue&type=template&id=f86fd256&scoped=true"
import script from "./Exci.vue?vue&type=script&lang=js"
export * from "./Exci.vue?vue&type=script&lang=js"
import style0 from "./Exci.vue?vue&type=style&index=0&id=f86fd256&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f86fd256",
  null
  
)

export default component.exports